import mapValues from "lodash.mapvalues";
import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import { requiredOptionMessage } from "../../../../utilities/validationMessages";
import {
  cityValidator,
  emailValidatorRequired,
  nameSurnameValidatorRequired,
  phoneValidator,
  postalCodeGenericValidator,
  postalCodePolandValidator,
  provinceValidator,
  radioValidator,
  streetHouseNumberValidator,
  streetValidator,
} from "../../../../utilities/validators";
import { trimmedString } from "../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

const multiPersonValidator = {
  persons: yup.lazy((obj) =>
    yup.object(
      mapValues(obj, (_, key) =>
        yup.object({
          name: nameSurnameValidatorRequired,
          surname: nameSurnameValidatorRequired,
          phone: phoneValidator(`additionalpersons${key}phone`),
          role: radioValidator,
          email: emailValidatorRequired,
          street: streetValidator,
          street2: streetHouseNumberValidator,
          zipCodePL: trimmedString.onlyIfFieldIsVisible(
            postalCodePolandValidator
          ),
          zipCodeGeneric: trimmedString.onlyIfFieldIsVisible(
            postalCodeGenericValidator
          ),
          city: cityValidator,
          province:
            trimmedString.onlyIfFieldIsVisibleProvince(provinceValidator),
        })
      )
    )
  ),
};

export const validator = {
  [FormId.APPLICANT_ADDITIONAL]: yup.object({
    [ComponentId.APPLICANT_ADDITIONAL_ARE_OTHER_PEOPLE_INVOLVED]: yup
      .string()
      .required(requiredOptionMessage),
    ...multiPersonValidator,
  }),
};
